<template>
    <section id="Wizard" :style="{minHeight: $route.path === '/wizard/preview' && winWidth < 991? '2175px': 'calc(100vh -135px)'}">
        <div class="wizard-place">
            <div class="container-fluid px-0">
                <div class="row mx-sm-auto mx-0">
                    <div class="col-12 px-sm-auto px-0">
                        <WizardSteps
                            @parentPrompt="prompt = $event" 
                            @step="step = $event"
                            :parent-prompt="prompt"
                            :routeTo="routeTo"
                            />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import WizardSteps from '@/components/WizardSteps.vue'
    export default {
        name: "Wizard",
        components: { 
            WizardSteps,
        },
        data() {
            return {
                prompt: false,
                step: '',
                routeTo: null
            }
        },
        computed: {
            winWidth: () => window.innerWidth
        },
        beforeRouteLeave(to, from, next) {
            if((this.step < 4 && this.step > 0 ) && this.prompt === false) {
                this.routeTo = to
                this.prompt = true 
                return
            }
            next()
        },
    }
</script>

<style scoped lang="scss">
section#Wizard {
    min-height: calc(100vh - 135px);
    background: linear-gradient(to left, #727CF5 48%,#727CF5 0%,#727CF5 45%,#727cf5b3 45%,#727cf5b3 100%);
}

</style>